export const tailwindClasses = {
  mainWrap: "main-wrapper pb-[38px] lg:pb-[48px]",
  headingWrap: "border-l-4 pl-[8px] bold-italic mb-[26px]",
  // hotelListCls: 'row md:flex-row flex-col mt-[30px]',
  // hotelWrap: "col-4 mb-[30px] sm:w-full",
  subHotelWrap: "bg-white rounded-lg shadow-lg w-[100%] relative",
  imgWrap: "overflow-hidden rounded-t-lg w-full h-[245px] bg-[#f0efef]",
  imgClass:
    "w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110",
  titleWrap: " w-full bottom-0 bg-whiterounded-b-lg",
  heading:
    "capitalize font-bold mb-2 text-2xl text-[#58A4AE] border-l-0 whitespace-break-spaces",
  // linkCls: "font-semibold cursor-pointer hover:text-[#58A4AE]",
  buttons:
    "w-[50%] uppercase font-bold text-[14px] p-[5px] bg-[#58a4ae] text-[#fff] cursor-pointer transition-transform duration-300 ease-in-out",
};
